/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { homeAction, profileAction } from "@redux/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";
import "swiper/css/free-mode";
import "swiper/css/thumbs";

// Styles
import "./styles.scss";

// Toastify
import showMessage from "@components/ShowMessage";
import showErrMessage from "@components/ShowErrMessage";

import SurveyBanner from "@assets/images/bg-survey.png";

const HomeSurvey = () => {
  const dispatch = useDispatch();
  const surveyList = useSelector((store) => store.home.surveyList);
  const surveyResult = useSelector((store) => store.home.surveyResult);

  useEffect(() => {
    dispatch(homeAction.getHomepageSurvey()).then((e) => {
      if (e.isHttpSuccess) {
        if (e?.data?.content) {
          for (const survey of e.data.content) {
            if (survey?.answeredSurvey === true) {
              dispatch(homeAction.getSurveyResult(survey.id));
            }
          }
        }
      }
    });
    return () => {};
  }, [dispatch]);

  const vote = (e, surveyId) => {
    e.preventDefault();
    const input = document.querySelector("input[name='surveyChoice']:checked");

    if (input) {
      dispatch(homeAction.setHomepageSurvey(parseInt(surveyId), input.value))
        .then((res) => {
          if (res.isHttpSuccess) {
            dispatch(homeAction.getHomepageSurvey()).then((e) => {
              if (e.isHttpSuccess) {
                if (e?.data?.content) {
                  for (const survey of e.data.content) {
                    if (survey?.answeredSurvey === true) {
                      dispatch(homeAction.getSurveyResult(survey.id)).then(
                        (response) => {
                          showMessage(
                            `Anketimizi cevapladınız ve ${response.data.score} puan kazandınız!`
                          );
                        }
                      );
                    }
                  }
                }
              }
            });

            setTimeout(() => {
              dispatch(profileAction.getLoginUserDetail());
            }, 2000);
          } else {
            showErrMessage(
              "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz!"
            );
          }
        })
        .catch((err) => {
          if (err.isHttpError) {
            showErrMessage(err.message);
          }
        });
    }
  };

  // BLG-04: Aktif anket yoksa bölümü tamamen gizle (büyük boş hero alanı
  // göstermek yerine hiç render etme).
  const hasActiveSurvey =
    surveyList?.content?.filter((survey) => survey !== null)?.length > 0;

  if (!hasActiveSurvey) {
    return null;
  }

  return (
    <section className="survey-section section-gray pt-5 pb-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-5 text-center">
            <img
              src={SurveyBanner}
              alt=""
              className="img-fluid w-100 max-w-450"
            />
          </div>
          <div className="col-lg-6 col-md-7">
            {
              <form
                onSubmit={(event) => {
                  const validSurveys = surveyList?.content?.filter(
                    (survey) => survey !== null
                  );
                  vote(event, validSurveys[0]?.id);
                }}
              >
                <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-md-start text-md-start text-center mb-4 mb-md-5">
                  {(() => {
                    const validSurveys = surveyList?.content?.filter(
                      (survey) => survey !== null
                    );
                    const currentSurvey = validSurveys?.[0];
                    return (
                      <h1 className="mb-0" style={{ fontSize: "1.8rem" }}>
                        {currentSurvey?.title || "Anket"}
                      </h1>
                    );
                  })()}
                  <span className="text-blue-light small ms-md-2 mt-1 mt-md-0">
                    {(() => {
                      const validSurveys = surveyList?.content?.filter(
                        (survey) => survey !== null
                      );
                      const currentSurvey = validSurveys?.[0];
                      return currentSurvey?.answeredSurvey === true ? (
                        <React.Fragment>
                          Katılımınız için teşekkürler!
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <i className="fas fa-lightbulb me-2"></i>
                          Katıl, {currentSurvey?.score} puan kazan!
                        </React.Fragment>
                      );
                    })()}
                  </span>
                </div>

                <h4 className="mb-sm-5 mb-4 lh-base text-md-start text-center">
                  {(() => {
                    const validSurveys = surveyList?.content?.filter(
                      (survey) => survey !== null
                    );
                    return validSurveys?.[0]?.description;
                  })()}
                </h4>

                {(() => {
                  const validSurveys = surveyList?.content?.filter(
                    (survey) => survey !== null
                  );
                  const currentSurvey = validSurveys?.[0];
                  return (
                    !surveyResult &&
                    currentSurvey?.surveyChoiceDTOList?.length > 0 && (
                      <div className="row row-cols-2 g-sm-4 g-3 mb-sm-5 mb-4">
                        {currentSurvey?.surveyChoiceDTOList.map((item, i) => (
                          <div className="col" key={item.id}>
                            <div
                              className={`form-check form-check-lg${
                                currentSurvey?.answeredSurvey ? " ps-0" : ""
                              }`}
                            >
                              {!currentSurvey?.answeredSurvey && (
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="surveyChoice"
                                  id={"option" + item.id}
                                  value={item.id}
                                  defaultChecked={i === 0}
                                />
                              )}

                              <label
                                className="form-check-label h6 text-gray-dark mb-0"
                                htmlFor={"option" + item.id}
                              >
                                {item.name.replace(/<\/?[^>]+(>|$)/g, "")}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    )
                  );
                })()}

                <div className="row row-cols-2 g-sm-4 g-3 mb-sm-0 mb-0">
                  {surveyResult?.surveyChoiceDTOList.map((item) => (
                    <div className="col" key={item.name}>
                      <div
                        className={`form-check form-check-lg${
                          surveyResult?.answeredSurvey ? " ps-0" : ""
                        }`}
                      >
                        <label className="form-check-label h6 text-gray-dark mb-0">
                          {item.name.replace(/<\/?[^>]+(>|$)/g, "")}
                          <span className="small text-green ms-2">
                            %
                            {item.choicePercent
                              ? item.choicePercent.toFixed(2)
                              : 0}
                          </span>
                        </label>
                      </div>
                    </div>
                  ))}
                </div>

                {(() => {
                  const validSurveys = surveyList?.content?.filter(
                    (survey) => survey !== null
                  );
                  const currentSurvey = validSurveys?.[0];
                  return !currentSurvey?.answeredSurvey ? (
                    <div className="text-sm-start text-center">
                      <button
                        type="submit"
                        className="btn btn-blue rounded-pill py-sm-3 py-2 px-sm-4 px-3"
                      >
                        Gönder
                      </button>
                    </div>
                  ) : null;
                })()}
              </form>
            }
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeSurvey;
